import { VALIDATION_PATTERNS } from '../../../../constants/validationPatterns';
import {
    DetailedBookingIMPPartialDataFields
} from '../../../CreateBooking/interface/DetailedBookingInterface';

export interface ContextualNodesIMPProps {
    imSegment: string;
    valueToBeLockedAtPackageLevel: number;
    impressions: number;
    approxShareBlockedOverNode: number;
}

interface ValidateIMPFieldsProps {
    formData: DetailedBookingIMPPartialDataFields,
    contextualNodes: ContextualNodesIMPProps[],
    t: (key: string) => string
}

// IMP- Impressions based booking : for GP class 1, NGP type of purchase behaviour.
const getIMPFormErrors = (formData: DetailedBookingIMPPartialDataFields, t: (key: string) => string) => {
    return {
        entryNumber: '',
        slotForGP: !formData.slotForGP.trim()
            ? t('slot-for-gp-required-error')
            : '',
        valueBlockedByLineItem: !formData.valueBlockedByLineItem
            ? t('value-blocked-by-line-item-required-error')
            : !VALIDATION_PATTERNS.NUMERIC.test(
                formData.valueBlockedByLineItem?.toString()
            )
                ? t('value-blocked-by-line-item-invalid-error')
                : '',
        impressionsBlockedOverContextualNode:
            !formData.impressionsBlockedOverContextualNode?.toString()
                ? t('impressions-blocked-over-contextual-node-required-error')
                : !VALIDATION_PATTERNS.NUMERIC.test(
                    formData.impressionsBlockedOverContextualNode?.toString()
                )
                    ? t('impressions-blocked-over-contextual-node-invalid-error')
                    : '',
        imSegment: '',
        valueToBeLockedAtPackageLevel: '',
        impressions: '',
        approxShareBlockedOverNode: '',
    }
}

const getIMPFormContextualNodeErrors = (contextualNodes: ContextualNodesIMPProps[], t: (key: string) => string) => {
    return contextualNodes.map((node) => ({
        imSegment: !node.imSegment.trim()
            ? t('contextual-node-im-segment-required-error')
            : '',
        valueToBeLockedAtPackageLevel: !node.valueToBeLockedAtPackageLevel
            ? t('contextual-node-value-to-be-locked-required-error')
            : !VALIDATION_PATTERNS.NUMERIC.test(
                node.valueToBeLockedAtPackageLevel?.toString()
            )
                ? t('contextual-node-value-to-be-locked-invalid-error')
                : '',
        impressions: !node.impressions
            ? t('contextual-node-impressions-required-error')
            : !VALIDATION_PATTERNS.NUMERIC.test(node.impressions?.toString())
                ? t('contextual-node-impressions-invalid-error')
                : '',
        // This is specifically checked for undefined and null as 0 is an acceptable value for this field
        approxShareBlockedOverNode: (node.approxShareBlockedOverNode === undefined || node.approxShareBlockedOverNode === null)
            ? t('contextual-node-approx-share-required-error')
            : !VALIDATION_PATTERNS.PERCENTAGE.test(
                node.approxShareBlockedOverNode?.toString()
            )
                ? t('contextual-node-approx-share-invalid-error')
                : '',
    }));
}

export const validateDetailedBookingIMPFields = ({ formData, contextualNodes, t }: ValidateIMPFieldsProps) => {
    const mainFormErrors = getIMPFormErrors(formData, t);
    const contextualNodeErrors = getIMPFormContextualNodeErrors(contextualNodes, t);

    return {
        mainFormErrors,
        contextualNodeErrors
    };
};